<button mat-icon-button color="accent" aria-label="Меню" (click)="openMenu()">
    <mat-icon>menu</mat-icon>
</button>